import React, { createContext, useContext } from 'react'
import { tsCodeSetValue } from '../../Typescript/API_Response'
import DrawerConfig from '../../DrawerMenus/DrawerConfig'
import ReportMenu from '../../DrawerMenus/MenuItems/ReportMenu'
import { Box } from '@mui/material'
import { drawer } from '../../garvan-react/Constants/StyleConstants'
import { useGetCodeSet } from '../../APIs/Hooks/CodeSetHooks'
import { UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'

interface ReportContextType {
  trafficLightQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  tissueTypeQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  genotypeServiceQuery: UseQueryResult<
    tsCodeSetValue[],
    AxiosResponse<any, any>
  >
  weaningCullChoiceQuery: UseQueryResult<
    tsCodeSetValue[],
    AxiosResponse<any, any>
  >
  yesNoQuery: UseQueryResult<tsCodeSetValue[], AxiosResponse<any, any>>
  breeedingChoiceQuery: UseQueryResult<
    tsCodeSetValue[],
    AxiosResponse<any, any>
  >
}

const ReportContext = createContext<ReportContextType>({} as ReportContextType)
export const useReportContext = () => useContext(ReportContext)

function ReportModule({ children }: { children: any }) {
  const trafficLightQuery = useGetCodeSet('TrafficLightColourID')
  const tissueTypeQuery = useGetCodeSet('TISCollectionTypeID')
  const genotypeServiceQuery = useGetCodeSet('GenotypeServiceID')
  const weaningCullChoiceQuery = useGetCodeSet('WeaningCullChoiceID')
  const yesNoQuery = useGetCodeSet('YesNoID')
  const breeedingChoiceQuery = useGetCodeSet('BreedingChoiceID')

  return (
    <ReportContext.Provider
      value={{
        trafficLightQuery,
        tissueTypeQuery,
        genotypeServiceQuery,
        weaningCullChoiceQuery,
        yesNoQuery,
        breeedingChoiceQuery,
      }}
    >
      <Box
        sx={{
          width: 1,
          pl: drawer / 10,
          pr: { xl: drawer / 10 }, //center if enough space
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <DrawerConfig itemsInit={ReportMenu} />
        {children}
      </Box>
    </ReportContext.Provider>
  )
}

export default ReportModule
